function Picker(_props) {
  throw new Error("Swift.Picker requires an iOS native build");
}
function DatePicker(_props) {
  throw new Error("Swift.DatePicker requires an iOS native build");
}
function ColorPicker(_props) {
  throw new Error("Swift.ColorPicker requires an iOS native build");
}
function MultiDatePicker(_props) {
  throw new Error("Swift.MultiDatePicker requires an iOS native build");
}
function Toggle(_props) {
  throw new Error("Swift.Toggle requires an iOS native build");
}
function Slider(_props) {
  throw new Error("Swift.Slider requires an iOS native build");
}
function Stepper(_props) {
  throw new Error("Swift.Stepper requires an iOS native build");
}
function PasteButton(_props) {
  throw new Error("Swift.PasteButton requires an iOS native build");
}
function Text(_props) {
  throw new Error("Swift.Text requires an iOS native build");
}
function Label(_props) {
  throw new Error("Swift.Label requires an iOS native build");
}
function ProgressView(_props) {
  throw new Error("Swift.ProgressView requires an iOS native build");
}
function Gauge(_props) {
  throw new Error("Swift.Gauge requires an iOS native build");
}
function Image(_props) {
  throw new Error("Swift.Image requires an iOS native build");
}
function ShareLink(_props) {
  throw new Error("Swift.ShareLink requires an iOS native build");
}
function ContentUnavailableView(_props) {
  throw new Error("Swift.ContentUnavailableView requires an iOS native build");
}
function Circle(_props) {
  throw new Error("Swift.Circle requires an iOS native build");
}
function Capsule(_props) {
  throw new Error("Swift.Capsule requires an iOS native build");
}
function Rectangle(_props) {
  throw new Error("Swift.Rectangle requires an iOS native build");
}
function RoundedRectangle(_props) {
  throw new Error("Swift.RoundedRectangle requires an iOS native build");
}
function Ellipse(_props) {
  throw new Error("Swift.Ellipse requires an iOS native build");
}
function UnevenRoundedRectangle(_props) {
  throw new Error("Swift.UnevenRoundedRectangle requires an iOS native build");
}
function ConcentricRectangle(_props) {
  throw new Error("Swift.ConcentricRectangle requires an iOS native build");
}
function LinearGradient(_props) {
  throw new Error("Swift.LinearGradient requires an iOS native build");
}
function RadialGradient(_props) {
  throw new Error("Swift.RadialGradient requires an iOS native build");
}
function EllipticalGradient(_props) {
  throw new Error("Swift.EllipticalGradient requires an iOS native build");
}
function AngularGradient(_props) {
  throw new Error("Swift.AngularGradient requires an iOS native build");
}
function MeshGradient(_props) {
  throw new Error("Swift.MeshGradient requires an iOS native build");
}
function VideoPlayer(_props) {
  throw new Error("Swift.VideoPlayer requires an iOS native build");
}
function LivePhotoView(_props) {
  throw new Error("Swift.LivePhotoView requires an iOS native build");
}
function PhotosPicker(_props) {
  throw new Error("Swift.PhotosPicker requires an iOS native build");
}
function WebView(_props) {
  throw new Error("Swift.WebView requires an iOS native build");
}
function SignInWithAppleButton(_props) {
  throw new Error("Swift.SignInWithAppleButton requires an iOS native build");
}
function PayWithApplePayButton(_props) {
  throw new Error("Swift.PayWithApplePayButton requires an iOS native build");
}
function AddPassToWalletButton(_props) {
  throw new Error("Swift.AddPassToWalletButton requires an iOS native build");
}
function Map(_props) {
  throw new Error("Swift.Map requires an iOS native build");
}
function MapCompass(_props) {
  throw new Error("Swift.MapCompass requires an iOS native build");
}
function MapPitchToggle(_props) {
  throw new Error("Swift.MapPitchToggle requires an iOS native build");
}
function MapUserLocationButton(_props) {
  throw new Error("Swift.MapUserLocationButton requires an iOS native build");
}
function TextField(_props) {
  throw new Error("Swift.TextField requires an iOS native build");
}
function SecureField(_props) {
  throw new Error("Swift.SecureField requires an iOS native build");
}
function TextEditor(_props) {
  throw new Error("Swift.TextEditor requires an iOS native build");
}
function Alert(_props) {
  throw new Error("Swift.Alert requires an iOS native build");
}
function ConfirmationDialog(_props) {
  throw new Error("Swift.ConfirmationDialog requires an iOS native build");
}
function QuickLook(_props) {
  throw new Error("Swift.QuickLook requires an iOS native build");
}
function FileImporter(_props) {
  throw new Error("Swift.FileImporter requires an iOS native build");
}
function Chart(_props) {
  throw new Error("Swift.Chart requires an iOS native build");
}
function AsyncImage(_props) {
  throw new Error("Swift.AsyncImage requires an iOS native build");
}
function EditButton(_props) {
  throw new Error("Swift.EditButton requires an iOS native build");
}
function EmptyView(_props) {
  throw new Error("Swift.EmptyView requires an iOS native build");
}
function LocationButton(_props) {
  throw new Error("Swift.LocationButton requires an iOS native build");
}
function ProductView(_props) {
  throw new Error("Swift.ProductView requires an iOS native build");
}
function RenameButton(_props) {
  throw new Error("Swift.RenameButton requires an iOS native build");
}
function ShortcutsLink(_props) {
  throw new Error("Swift.ShortcutsLink requires an iOS native build");
}
function StoreView(_props) {
  throw new Error("Swift.StoreView requires an iOS native build");
}
function SubscriptionStoreView(_props) {
  throw new Error("Swift.SubscriptionStoreView requires an iOS native build");
}
var unsupportedControls = {
  Picker,
  DatePicker,
  ColorPicker,
  MultiDatePicker,
  Toggle,
  Slider,
  Stepper,
  PasteButton,
  Text,
  Label,
  ProgressView,
  Gauge,
  Image,
  ShareLink,
  ContentUnavailableView,
  Circle,
  Capsule,
  Rectangle,
  RoundedRectangle,
  Ellipse,
  UnevenRoundedRectangle,
  ConcentricRectangle,
  LinearGradient,
  RadialGradient,
  EllipticalGradient,
  AngularGradient,
  MeshGradient,
  VideoPlayer,
  LivePhotoView,
  PhotosPicker,
  WebView,
  SignInWithAppleButton,
  PayWithApplePayButton,
  AddPassToWalletButton,
  Map,
  MapCompass,
  MapPitchToggle,
  MapUserLocationButton,
  TextField,
  SecureField,
  TextEditor,
  Alert,
  ConfirmationDialog,
  QuickLook,
  FileImporter,
  Chart,
  AsyncImage,
  EditButton,
  EmptyView,
  LocationButton,
  ProductView,
  RenameButton,
  ShortcutsLink,
  StoreView,
  SubscriptionStoreView
};
export {
  unsupportedControls
};
//# sourceMappingURL=unsupportedControls.js.map
